var _rect, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnxiety(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 80,
    height: 80,
    fill: "#E87722"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.4112 59.114C67.0118 53.7304 70.5002 46.1568 70.5002 37.7645C70.5026 21.4264 57.2779 8.18115 40.9652 8.18115C24.6524 8.18115 11.4277 21.4264 11.4277 37.7645C11.4277 54.1026 24.6524 67.3478 40.9652 67.3478C44.6981 67.3478 48.2704 66.6515 51.5574 65.386L63.9909 71.8189L61.4112 59.114Z",
    stroke: "white",
    strokeWidth: 5.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5 53.3333C49.0021 49.4414 45.0907 46.6667 40.5 46.6667C35.9093 46.6666 31.9979 49.4427 30.5 53.3333",
    stroke: "white",
    strokeWidth: 5.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8333 26.6667C51.6111 27.2222 46.8333 29.3334 45.5 33.3334C50.5 33.3334 60.5 36.6667 60.5 36.6667",
    stroke: "white",
    strokeWidth: 5.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8334 26.6667C31.0556 27.2222 35.8334 29.3334 37.1667 33.3334C32.1667 33.3334 22.1667 36.6667 22.1667 36.6667",
    stroke: "white",
    strokeWidth: 5.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnxiety);
export default __webpack_public_path__ + "static/media/anxiety.4dd8763a408a878ad718c85c898374d1.svg";
export { ForwardRef as ReactComponent };